import React from 'react';

import FormInput from '../../components/form-input/form-input.component';
import CustomButton from '../../components/custom-button/custom-button.component';
import Button from '@material-ui/core/Button';

import { auth, createUserProfileDocument } from '../../firebase/firebase.utils';

import { SignUpContainer, RegistrationContainer, TitleContainer, InputTermsBox, LogoContainer } from './sign-up-page.styles';
import history from '../../history';
import { DIOCESE_TERMS_DOC } from '../../constants';



class SignUpPage extends React.Component {

    constructor() {
        super();

        this.state = {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            password: '',
            confirmPassword: '',
            termsChecked: false 
        }
    }
    
    handleSubmit = async event => {
       event.preventDefault();

       const {firstName, lastName, phone, email, password, confirmPassword, termsChecked} = this.state;

       if (password !== confirmPassword) {
           alert("Passwords don't match!");
           return;
       }

       if ((firstName == null ) || (lastName == null) || (phone == null) || (email == null) || (termsChecked === false)) {
           alert("Some information is missing. Please complete the form and resubmit.");
           return;
       }

       try {
           const { user } = await auth.createUserWithEmailAndPassword(email, password);

           await createUserProfileDocument(user, { firstName, lastName, phone, termsChecked });

            this.setState({
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                password: '',
                confirmPassword: '',
                termsChecked: false 
           });
           alert("You have successfuly registered.\nClick OK to login!");
           history.push('/signin');
 

       } catch(error) {
           alert(error.message);
       }
    };

    handleChange = event => {
        const { name, value } = event.target;
        if (name === 'termsChecked') {
            this.setState({ termsChecked: !this.state.termsChecked });
        }
        else {
            this.setState({ [name]: value })
        }
        
    };


    render() {
        const {firstName, lastName, phone, email, password, confirmPassword} = this.state;
        return(
            <SignUpContainer>
            <RegistrationContainer>
                <LogoContainer>
                        <img id="logo" alt="logo"  src={require("../../assets/mrsLogo.png")} height="auto" width="100%" />
                </LogoContainer>
                <TitleContainer>Register for an account</TitleContainer>
                <span>Please provide all requested information. </span>
                <span>This information will only be used for this application.</span>
                <form  onSubmit={this.handleSubmit}>
                    <FormInput 
                        type='text' 
                        name='firstName' 
                        value={firstName} 
                        onChange={this.handleChange} 
                        label='First Name' 
                        required />
                    <FormInput 
                        type='text' 
                        name='lastName' 
                        value={lastName} 
                        onChange={this.handleChange} 
                        label='Last Name' 
                        required />
                    <FormInput 
                        type='text' 
                        name='phone' 
                        value={phone}
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" 
                        onChange={this.handleChange} 
                        label='Phone Number (format:123-456-7890)' 
                        required />
                    <FormInput 
                        type='email' 
                        name='email' 
                        value={email} 
                        onChange={this.handleChange} 
                        label='Email' 
                        required />
                    <FormInput 
                        type='password' 
                        name='password' 
                        value={password} 
                        onChange={this.handleChange} 
                        label='Password' 
                        required />
                    <FormInput 
                        type='password' 
                        name='confirmPassword' 
                        value={confirmPassword} 
                        onChange={this.handleChange} 
                        label='Confirm Password' 
                        required />
                    <InputTermsBox>
                        <input
                            name="termsChecked"
                            type="checkbox"
                            checked={this.state.termsChecked}
                            onChange={this.handleChange}
                            required />
                        <label><a href={DIOCESE_TERMS_DOC} target="_blank" rel="noopener noreferrer"><strong>&nbsp;I agree to abide with Diocesan Guidelines</strong></a></label>
                    </InputTermsBox>

                    <CustomButton type="submit">REGISTER</CustomButton>
                </form>
                <Button color="primary" style={{fontSize: "18px", marginTop: "20px", width: "300px", textAlign: "left"}} 
                    onClick={() => history.push('/signin')}>Return to Sign-in Page</Button>

            </RegistrationContainer>
            </SignUpContainer>
        );
    }

}


export default SignUpPage;